import React from 'react';

export function StepLocationLabel() {
  return <>Adresa a poloha</>;
}
